module.exports = __webpack_public_path__ + "img/5.2c17d326.jpg";